<template>
  <div class="news-container">
    <div class="header">
      <div class="title">
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x6.png" alt="">
        <span>新闻<span class="highlight">动态</span></span>
        <div class="ll"></div>
        <span class="lll">NEWS INFORMATION</span>
      </div>
      <div  @click="goNext('/xwzx')" class="more">
        查看更多 <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x7.png" alt="">
      </div>
    </div>
    <div class="news-list">
      <div style="cursor: pointer;" class="news-item" @click="goNext(`/xwxq?id=${item.id}`)" v-for="(item, index) in newsList" :key="index">
        <div class="tag">新闻动态</div>
        <div class="news-title twoEllipsis">{{ item.title }}</div>
        <div class="line"></div>
        <div class="news-introduction fireElp">{{ item.introduction }}</div>
      </div>
    </div>
    <img style="width: 1400px;margin-top: 30px;" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x8.png"
      alt="">
  </div>
</template>

<script>
import { queryAllArticle } from "@/api/home";

export default {
  name: "NewsDynamic",
  data() {
    return {
      newsList: [      ]
    };
  },
  created() {
    this.getList()

  },
  methods: {
    async getList() {

      return queryAllArticle("", 5, 1).then((res) => {
        // 首页摘要使用纯文本，避免新接口正文中的标签直接显示在卡片上。
        this.newsList = res.rows.map((item) => ({
          ...item,
          introduction: String(item.introduction || "").replace(/<[^>]*>/g, ""),
        }));
      });
    },
  }

};
</script>

<style lang="scss" scoped>
.news-container {
  max-width: 1400px;
  margin: 0 auto;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  margin-top: 40px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.title {
  display: flex;
  align-items: center;

  font-family: DingTalk JinBuTi, DingTalk JinBuTi;
  font-weight: 400;
  font-size: 34px;

  img {
    width: 41px;
    margin-right: 9px;
  }

  .ll {
    margin: 0 17px;
    width: 0px;
    height: 28px;
    border-right: 1px solid #BBBBBB;
  }

  .lll {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #999999;
  }
}

.title .icon-news {
  width: 20px;
  height: 20px;
  background-color: #007bff;
  border-radius: 50%;
  margin-right: 8px;
}

.title .highlight {
  color: #007bff;
  margin-left: 4px;
}



.more {
  cursor: pointer;
  display: flex;
  align-items: center;

  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #666666;

  img {
    width: 31px;
    margin-left: 4px;
  }
}



.news-list {
  display: flex;
  justify-content: space-between;
}

.news-item {
  width: 265px;
  height: 268px;
  background: #FFFFFF;
  border-radius: 10px 10px 10px 10px;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  &:hover{
    background: linear-gradient( 225deg, #F0F4F9 0%, rgba(255,255,255,1) 80%);
  }
}

.tag {
  width: 58px;
  height: 18px;
  background: #B2C6DE;
  border-radius: 2px 2px 2px 2px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 300;
  font-size: 12px;
  color: #FFFFFF;
  margin-bottom: 10px;
  text-align: center;
}

.news-title {
  width: 217px;
  height: 56px;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 16px;line-height: 28px;
  color: #333333;
  /* 限制两行高度 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.line {
  width: 100%;
  height: 1px;
  border-bottom: none;
  background-image: linear-gradient(to right,
      #e5e5e5 50%,
      transparent 50%);
  background-size: 12px 1px;
  background-position: 0 bottom;
  background-repeat: repeat-x;
  margin: 14px 0;
}

.news-introduction {
  width: 224px;
  height: 121px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  /* 限制三行高度 */
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 12px;
  line-height: 28px;
}

.image-placeholder {
  background-color: #ddd;
  height: 80px;
  border-radius: 4px;
  text-align: center;
  line-height: 80px;
  color: #999;
  font-size: 14px;
}
.swImg{
  img{
    width: 100%;
  }

}
</style>
